import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiFetch } from '../../utils/api';
import './TrainingVideoPlayer.css';

const TrainingVideoPlayer = () => {
  const { departmentName, videoId } = useParams();
  const navigate = useNavigate();
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVideo = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await apiFetch(
          `${window._env_.API_BASE_URL}/training-videos/${videoId}`
        );
        setVideo(data);
      } catch (err) {
        console.error('Error fetching training video:', err);
        setError(err.message || 'Failed to load video');
      } finally {
        setLoading(false);
      }
    };

    if (videoId) {
      fetchVideo();
    }
  }, [videoId]);


  if (loading) {
    return (
      <div className="tvp-container">
        <div className="tvp-loading">Loading video...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tvp-container">
        <div className="tvp-error">
          <p>Error: {error}</p>
        </div>
      </div>
    );
  }

  if (!video) {
    return (
      <div className="tvp-container">
        <div className="tvp-error">
          <p>Video not found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tvp-container">
      <div className="tvp-back-btn" onClick={() => navigate(-1)}>
        ← Back
      </div>
      <div className="tvp-video-wrapper">
        <div className="tvp-video-container">
          {video.video_url ? (
            <video
              controls
              className="tvp-video"
              src={video.video_url}
            >
              Your browser does not support the video tag.
            </video>
          ) : (
            <div className="tvp-no-video">
              <p>Video URL not available</p>
            </div>
          )}
        </div>
      </div>

      <h1 className="tvp-title">{video.title}</h1>

      {video.description && (
        <div className="tvp-description">
          <h2>Description</h2>
          <p>{video.description}</p>
        </div>
      )}
    </div>
  );
};

export default TrainingVideoPlayer;

